export enum RouteKeys {
  List = '/payment',
  Details = '/payment/:id',
}
